var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 500.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M596.17 458.86L325.14 13.8a29.74 29.74 0 00-50.21 0L3.9 458.86a26.19 26.19 0 000 27.5 29.35 29.35 0 0025.1 13.7h542.07a29.6 29.6 0 0025.1-13.7 26.58 26.58 0 000-27.5zm-90.6-4.78a18.45 18.45 0 01-16 9.14H110.4a18.42 18.42 0 01-16-9.14 18.11 18.11 0 010-18.15L284.06 113a18.56 18.56 0 0132 0l189.51 322.93a18.16 18.16 0 010 18.15z",
    fill: "#a2272d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M291.41 423.52c-9.38-4.49-16.53-15.3-16.53-25 0-18 18.86-31.64 36.7-26.45a27.63 27.63 0 0120.12 26.71c-.09 10.49-4.63 18.22-13.9 23.65-7.09 4.16-18.96 4.65-26.39 1.09zm2.13-71.26a42.59 42.59 0 01-6.14-5c-7.69-7.33-7.68-7.27-12.7-85.69-4.46-69.72-4.5-70.8-2.58-75.81 4.3-11.26 13.89-16.2 29.86-15.36 10.15.53 18 4.1 23 10.51 4.34 5.48 5.29 8.58 5.28 17.33 0 9.51-6.08 126.14-6.94 133.28-1.13 9.36-6.6 17-14.61 20.3-4.57 1.92-12.13 2.12-15.22.42z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.11fed0d9.svg";
export { ForwardRef as ReactComponent };